module.exports = __webpack_public_path__ + "assets/media/day27.69b7eedb.mp3";